import ingealimentosApi, { getDomain } from '../../services/ingealimentosApi'

export const getServiceReports = params => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.get('/service_reports', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getServiceReport = (id, params) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.get(`/service_reports/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getPublicServiceReport = (id, params) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.get(`/public/service_reports/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeServiceReport = data => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.post('/service_reports', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateServiceReport = (id, data) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.put(`/service_reports/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteServiceReport = id => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.delete(`/service_reports/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const notifyServiceReport = id => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.post(`/service_reports/notify/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)


export const searchServiceReports = async (term, token) => (
	fetch( getDomain()+`/service_reports?filter[name]=${term}`, {
		headers: {'Authorization': `Bearer ${token}`}
	})
		.then((response) => response.json())
		.then((res) =>
			res.data.map(item => ({
				label: item.name,
				value: item.id,
			})),
		)
)